<template>
  <swiper-slide>
    <div class="main-slider-slide-content">
      <v-container class="pa-0" fluid>
        <v-row class="justify-lg-end">
          <v-col lg="7">
            <div class="main-slider-slide-title">{{ this.title }}</div>
            <div class="main-slider-slide-text mt-1">{{ this.text }}</div>
            <div class="d-flex justify-start mt-6">
              <v-btn 
                height="48"
                variant="flat"
                color="#00AA8A"
                @click="routeTo">
                {{ this.btnText }}
              </v-btn>
            </div>
          </v-col>
        </v-row>  
      </v-container>
    </div>
  </swiper-slide>
</template>
  
<script>
  export default {
    name: 'MainSliderSlide',
    props: {
      title: String,
      text: String,
      btnText: String,
      btnLink: String,
      LinkName: String,
      linkPath: String
    },
    methods:{
      routeTo(){
        this.$router.push({name: this.LinkName, path: this.linkPath})
      }
    }
  }
</script>
